const WISTIA = {
  CONFIG_URL: 'https://fast.wistia.com/assets/external/E-v1.js',
  CONFIG_MEDIA_URL: 'https://fast.wistia.com/embed/medias/',
  CONFIG_MEDIA_EXT: '.jsonp',
  NO_VIEW_ENQUIRIES: 'xo066abb2x',
  SUCCESS: ['h10pl8exzo', 'pnhgy75cfj', 'nnchpg8g19'],
  WHAT_ARE_TOKENS: {
    B: 'https://clink-assets.s3.eu-west-2.amazonaws.com/production/prosper/videos/Tokens+video+1.mp4',
    A: 'https://clink-assets.s3.eu-west-2.amazonaws.com/production/prosper/videos/Token+video+2.mp4',
  },
  WHAT_ARE_TOKENS_MODAL: '48k33gepgr',
  HOW_IT_WORKS: {
    SHOW: [
      {
        id: 'csf0pcmd21',
        title: 'Messaging',
        description:
          "We know communicating during the tender is key to success and accurate pricing, so we've built an internal messaging service",
        link: 'wistia_embed wistia_async_csf0pcmd21 popover=true popoverAnimateThumbnail=true',
      },
      {
        id: 'utsgj1fn3a',
        title: 'Live projects and tokens',
        description:
          'We will connect you straight to the decision-maker on live project opportunities in just a couple of clicks.',
        link: 'wistia_embed wistia_async_utsgj1fn3a popover=true popoverAnimateThumbnail=true',
      },
      {
        id: 'eah7ntceu0',
        title: 'Prequalification',
        description:
          'Store all your relevant company and prequalification information in one place, so your clients can access it anytime without having to ask you.',
        link: 'wistia_embed wistia_async_eah7ntceu0 popover=true popoverAnimateThumbnail=true',
      },
      {
        id: 'ci0wuhaaqy',
        title: 'Enquiries and Quotes',
        description:
          "Once you're on the client's procurement schedule, they will safely and securely send you tender information which will be stored in your Prosper account.",
        link: 'wistia_embed wistia_async_ci0wuhaaqy popover=true popoverAnimateThumbnail=true',
      },
    ],
    HIDDEN: [
      {
        title: 'Tenders',
        description:
          "Once you're on the client's procurement schedule, they will safely and securely send you tender information via the C-Link portal",
        link: 'wistia_embed wistia_async_pnhgy75cfj popover=true popoverAnimateThumbnail=true',
      },
      {
        title: 'Notifications',
        description:
          'We will actively notify you of all interactions with the relevant tender, from prompting you to accept the tender to reminding you to upload the quote',
        link: 'wistia_embed wistia_async_nnchpg8g19 popover=true popoverAnimateThumbnail=true',
      },
      {
        title: 'Quoting',
        description:
          'When you get notified to return your tender, you will be prompted to upload your quote through our secure portal',
        link: 'wistia_embed wistia_async_pnhgy75cfj popover=true popoverAnimateThumbnail=true',
      },
      {
        title: 'Project management',
        description:
          "Once you've secured the project, your client can manage your works via the portal throughout the whole lifecycle of the project",
        link: 'wistia_embed wistia_async_nnchpg8g19 popover=true popoverAnimateThumbnail=true',
      },
    ],
  },
};

export default WISTIA;
